// extracted by mini-css-extract-plugin
module.exports = {"container":"_c187a56","header":"_5b483f7","title":"_70cfe07","body":"_3e50331","sizeSmall":"_6df41e6"};